export const POSTHOG_HOST_DEFAULT = 'https://us.i.posthog.com';
/**
 * Check if analytics should be enabled. Accepts the apiKey and env mode
 * as parameters since this package is compiled outside of Vite.
 */
export function isAnalyticsEnabled(apiKey, mode) {
    return !!apiKey && mode !== 'test';
}
export function getPostHogOptions(config) {
    return {
        api_host: config.host || POSTHOG_HOST_DEFAULT,
        autocapture: true,
        // 'history_change' also records the client-side route changes these SPAs make; `true` would
        // count only full page loads. The initial load is captured either way.
        capture_pageview: 'history_change',
        capture_pageleave: true,
        session_recording: {
            maskAllInputs: true,
            maskTextSelector: '.ph-no-capture',
            recordCrossOriginIframes: false,
        },
        disable_session_recording: false,
        person_profiles: 'identified_only',
    };
}
//# sourceMappingURL=config.js.map